import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  PageHeader
} from 'mailup-web-components'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { canCreateTrigger, isEmptyState } = useRecoilValue(pageState)

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.AutomationWorkflows' }),
      'data-mu-test': 'breadcrumb-item__automation-workflow',
      className: 'test-breadcrumb-item__automation-workflow'
    }
  ]

  const ControlsComponent = () => {
    const handleSaveClick = () => {
      history.push('/automation/workflow/0/edit')
    }

    return (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        className='test-buttonSave'
        data-mu-test='cta-save'
        onClick={handleSaveClick}
      >
        {intl.formatMessage({
          id: 'Load.AutomationWorkflow.NewAutomationWorkflow'
        })}
      </Button>
    )
  }

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['WorkFlows', redirectUrl])
  }, [redirectUrl])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={intl.formatMessage({ id: 'Load.NavMenu.AutomationWorkflows' })}
      ControlsComponent={
        canCreateTrigger && !isEmptyState ? ControlsComponent : false
      }
    />
  )
}

export default Header
